import { DataLayer } from './dataLayer';
import { formatMoney as _formatMoney } from './util';

export default function init () {
    var dataLayer = new DataLayer(function (impressions) {
        return {
            event: 'product-impression',
            ecommerce: {
                currencyCode: window.Shopify.currency.active || undefined,
                impressions: impressions,
            },
        };
    });

    /**
     * @param {string} list
     * @param {number} [position] 1-indexed
     */
    return function track (product, list, position) {
        var event = {
            name: product.title,
            id: product.id.toString(),
            price: _formatMoney(product.price),
            brand: product.vendor,
            category: product.type || undefined,
            variant: product.variant.title.toString(),
            list: list,
            position: typeof position === 'number'
                ? position.toString()
                : undefined,
            // product 'price type'
            dimension15: (
                product.variant.compare_at_price &&
                (product.variant.compare_at_price > product.variant.price)
            )
                ? 'sale'
                : 'msrp',
            // msrp
            metric2: _formatMoney(product.variant.compare_at_price || product.variant.price),
        };

        dataLayer.push(event);
    }
}